<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-4">
    <h2>Processo - Questão</h2>
    <h3>Admin</h3>
  </div>
  <div class="col-lg-8 d-flex justify-content-end d-wrap">
    <div class="new-project">
      <a class="btn btn-primary" [routerLink]="novo()">Novo</a>
    </div>
  </div>
</div>

<div class="system-table p-h-lg">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="width5">Código</th>
          <th>Nome</th>
          <th>Tipo</th>
          <th>Ativo</th>
          <th class="text-center width5">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of mainList">
          <tr>
            <td class="title">{{ item?.id }}</td>
            <td><span class="title-span">{{ item?.title }}</span></td>
            <td><span class="title-span">{{ typeList[item?.type_id]['label'] }}</span></td>
            <td><span class="title-span">{{ activeList[item?.actived]['label'] }}</span></td>
            <td>
              <div class="btn-icon">
                <a class="icon-table" [routerLink]="item?.id">
                  <img src="assets/images/svgs/editar1.svg" tooltip="Visualizar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!mainList?.length" class="border-b-radius">
          <td colspan="5" class="text-center">Nenhum Cadastro Encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>